import React from 'react';
import { PlanChooser, WikiWrapper } from 'apps/components';
import { routerStore } from 'core/routing';
import { BackButton } from 'components';
import { clientStore } from 'apps/client/app';

export enum PlanType {
  PRO = 'pro',
  BUSINESS = 'business',
}

export const UpgradePlanChooser = () => {
  const { spacePath } = routerStore.route.params;

  const navigateToUpgradePro = (productType: PlanType) => {
    routerStore.navigate('workspace.upgrade', {
      spacePath,
      productType,
    });
  };

  const navigateToCreateInitiative = (productType: PlanType) => {
    routerStore.navigate('home.newInitiative', {
      productType,
    });
  };

  return (
    <WikiWrapper
      hiddenLogo={clientStore.signedInProfile}
      headerRight={
        <BackButton
          className='relative right-1 text-black text-lg flex justify-center items-center'
          onClick={() => {
            history.back();
          }}
        />
      }
    >
      <PlanChooser
        hideSwitcher
        shouldShowOneRow
        className='h-full'
        onClickCompanyForTeam={() => {
          navigateToCreateInitiative(PlanType.PRO);
        }}
        onClickCompanyForBusiness={() => {
          navigateToCreateInitiative(PlanType.BUSINESS);
        }}
      />
    </WikiWrapper>
  );
};
